import React, { FunctionComponent } from 'react';
import ArticleNextPrevFooter from '../../components/article-next-prev-footer/ArticleNextPrevFooter';
import { ArticleType } from '../../../domain/articleType';
import { RELATED_NEWS_QUERY } from '../../graphql/queries/news';
import { RELATED_GUIDES_QUERY } from '../../graphql/queries/guide';
import { Target } from '../../../domain/graphcms';
import { getNextPrev, NextPrevResult } from '../../graphql/mappers/articleMappers';
import useQuery from '../../hooks/useQuery/useQuery';

export interface ArticleNextPrevFooterContainerProps {
  articleType: ArticleType,
  skipId: string,
  date: string,
  createdAt: string,
}

const mapQuery = {
  [ArticleType.NEWS]: RELATED_NEWS_QUERY,
  [ArticleType.GUIDE]: RELATED_GUIDES_QUERY,
  [ArticleType.EDUCATION]: RELATED_GUIDES_QUERY,
};

const ArticleNextPrevFooterContainer: FunctionComponent<ArticleNextPrevFooterContainerProps> = ({
  articleType,
  skipId,
  date,
  createdAt,
}) => {
  const variables = {
    skipId, date, count: 1, createdAt,
  };

  const { data, error } = useQuery({
    query: mapQuery[articleType],
    variables: articleType === ArticleType.NEWS
      ? variables
      : { ...variables, target: articleType === ArticleType.GUIDE ? [Target.COMPRATORE, Target.VENDITORE] : [Target.AGENTE] },
  });

  let nextPrev: NextPrevResult = {};

  if (data) {
    nextPrev = getNextPrev(data.older, data.newer, articleType);
  }

  return (
    <ArticleNextPrevFooter
      loading={!data}
      error={error}
      {...nextPrev}
    />
  );
};

export default ArticleNextPrevFooterContainer;
